'use client'

import { Home, Book, Globe, Wrench, FileText, User, Briefcase } from 'lucide-react'
import { NavBar } from '@/components/ui/tubelight-navbar'
import { AnnouncementBanner } from '@/components/shared/announcement-banner'

const navItems = [
  { name: 'Home', url: '/', icon: Home },
  { name: 'Destinations', url: '/destinations', icon: Globe },
  { name: 'Universities', url: '/universities', icon: Book },
  { name: 'Tools', url: '/tools', icon: Wrench },
  { name: 'Services', url: '/services', icon: Briefcase },
  { name: 'Blog', url: '/blog', icon: FileText },
  { name: 'About', url: '/about#global-footprint', icon: User },
]

export function Header() {
  return (
    <header className="sticky top-0 z-50">
      <AnnouncementBanner
        message="Launching GoAusbildung: All in one platform for Ausbildung in Germany."
        linkUrl="https://goausbildung.com"
        linkText="Check it out"
        dismissalKey="goausbildung-announcement"
      />
      <NavBar items={navItems} />
    </header>
  )
} 